import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { TABLES } from '../../../../Apis/Tables';
import { clearSearchFilters } from '../../../../reduxToolkit/Search/SearchSlice';
import { MODELS } from '../../../../Apis/Models';
import { useNavigate } from 'react-router-dom';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const LogsApp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const dispatch = useDispatch();
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [modified, setModified] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState(null);

    // The view only lists the platform access log, so its model is fixed
    const moduleId = `${MODELS.LogInLog}`;
    const option = `${TABLES.LOG_IN_LOG}`;

    useEffect(() => {
        return () => {
            dispatch(clearSearchFilters());
        };
    }, [dispatch]);

    return {
        t,
        modified,
        setModified,
        moduleId,
        option,
        finalArray,
        setFinalArray,
        filterDialogShow,
        setFilterDialogShow,
        DEV,
        permission,
        navigate,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        bodyForExport,
        setBodyForExport
    };
};

export default LogsApp;
